import { Tx } from "src/redux/Tx/types";
import { Inventory } from "src/redux/Inventory/types";
import { SpinnerActions } from "src/redux/Spinner/actions";
import { ModalActions } from "src/redux/Modal/actions";
import { TX_STATES } from "src/redux/Tx/constants";
import { ERRORS } from "src/redux/Inventory/constants";
import { SpinnerTypes } from "src/redux/Spinner/types";
import { ToasterActions } from "src/redux/Toaster/actions";
import { uniqueId } from "lodash";

export const WebWorkerActions = {
    getStockData: (data) => {
        let { listSecurityId, role, isInventoryStock } = data;
        return (dispatch, getState) => {
            const workerInstance = new Worker("workers/getStockWorker.js");

            // Post message to the worker
            workerInstance.postMessage(data);
            // Listen for messages from the worker
            workerInstance.onmessage = (response) => {
                const result = response.data;
                if (isInventoryStock) {
                    dispatch({
                        type: Inventory.MARKET_DATA_BATCH_UPDATE,
                        result,
                        listSecurityId,
                    });
                    dispatch({ type: Inventory.MARK_REPLACING_UPLOAD_ROW });
                } else {
                    dispatch({
                        type: Tx.GET_MARKET_DATA,
                        result,
                        role,
                        listSecurityId,
                    });
                }
                // Terminate the worker after processing the message
                workerInstance.terminate();
            };

            // Handle errors from the worker
            workerInstance.onerror = (err) => {
                console.error(err);

                // Terminate the worker in case of an error
                workerInstance.terminate();
            };
        };
    },
    sendOffer: (data) => {
        return (dispatch, getState) => {
            const workerInstance = new Worker("workers/sendOfferWorker.js");

            // Post message to the worker
            workerInstance.postMessage(data);
            dispatch(SpinnerActions.Close());
            dispatch(ModalActions.CloseAll());
            dispatch({
                type: Tx.INSERT_LEND_TX_LIST,
                txEntries: data.requestBody?.txSet.map((tx) => ({
                    id: uniqueId(`temp-${tx?.security?.isin}-`),
                    user: {
                        email: tx?.lastUser,
                    },
                    correlationId: "",
                    lender: {
                        id: null,
                        name: null,
                        ksdAccountSettings: {
                            accountNo: "",
                        },
                        ksfcAccountSettings: {
                            accountNo: "",
                        },
                        ksfcFundCode: "",
                        slbNumber: "",
                    },
                    borrower: {
                        id: data?.requestBody?.borrower?.id,
                        name: data?.requestBody?.borrower?.name,
                    },
                    state: TX_STATES.SENDING,
                    lastUpdated: Math.floor(Date.now() / 1000),
                    lastUser: tx?.lastUser,
                    createdAt: Math.floor(Date.now() / 1000),
                    expiresAt: "",
                    type: tx?.type || "LOAN",
                    myRole: "LENDER",
                    security: {
                        id: tx?.security?.id,
                        ticker: tx?.security?.ticker || "159580",
                        isin: tx?.security?.isin || "KR7159580000",
                        bbgCode: tx?.security?.bbgCode || "159580 KS",
                        ric: tx?.security?.ric || "159580.KQ",
                        name: "Pending",
                        localName: tx?.security?.localName || "제로투세븐",
                        market: tx?.security?.marketCode || "XKOS",
                        country: tx?.security?.countryCode || "KR",
                        currency: tx?.security?.countryCode || "KRW",
                        closingPrice: tx?.security?.closingPrice || 6930,
                        tradableDates: tx?.security?.tradableDates || [],
                    },
                    listName: tx?.security?.listName || "List A",
                    offeredEconomics: {
                        quantity: 100,
                        fee: {
                            rateBp: 149,
                        },
                        intermediary: "ANY",
                        txType: "ANY",
                        valueDate: tx?.security?.valueDate || "2024-03-06",
                        maturityDate:
                            tx?.security?.maturityDate || "9999-12-31",
                        callable: false,
                        dividend: tx?.security?.dividend || 100,
                    },
                    unsolicitedOffer: true,
                    internalFundCode: "01",
                    uniqueId: `TxEntry-`,
                    canceled: false,
                    createdDateAsISOStringRole: "2024-03-04+09:00_LENDER",
                    originOfferedEconomics: {
                        quantity: 100,
                        fee: {
                            rateBp: 149,
                        },
                        intermediary: "ANY",
                        txType: "ANY",
                        valueDate: tx?.valueDate || "2024-03-06",
                        maturityDate: tx?.maturityDate || "9999-12-31",
                        callable: false,
                        dividend: tx?.security?.dividend || 100,
                    },
                    idx: 31,
                })),
            });
            // Listen for messages from the worker
            workerInstance.onmessage = (response) => {
                const result = response.data;
                dispatch({
                    type: Tx.INIT_SENT,
                    correlationId: result.correlationId,
                });
                dispatch({
                    type: Tx.INSERT_LEND_TX_LIST,
                    txEntries: result.txSet.map((tx) => ({
                        ...tx,
                        correlationId: result.correlationId,
                        state: TX_STATES.OFFERED,
                    })),
                });

                dispatch({ type: Tx.RESET_INIT });
                dispatch(SpinnerActions.Close());
                dispatch(ModalActions.CloseAll());
                dispatch(ModalActions.Close());
                // Terminate the worker after processing the message
                workerInstance.terminate();
            };

            // Handle errors from the worker
            workerInstance.onerror = (err) => {
                console.error(err);
                dispatch(SpinnerActions.Close());
                dispatch({ type: Tx.INIT_ERROR, err });
                // Terminate the worker in case of an error
                workerInstance.terminate();
            };
        };
    },
    sendInitiate: (data) => {
        return (dispatch, getState) => {
            const workerInstance = new Worker("workers/initiateOfferWorker.js");

            // Post message to the worker
            workerInstance.postMessage(data);
            if (!data?.enableBatching) {
                dispatch(SpinnerActions.Close());
                dispatch(ModalActions.CloseAll());
                dispatch({
                    type: Tx.INSERT_BORROW_TX_LIST,
                    txSet: data.requestBody?.txSet.map((tx) => ({
                        id: !data?.enableBatching
                            ? uniqueId(`temp-${tx?.security?.isin}-`)
                            : undefined,
                        user: {
                            email: tx?.lastUser,
                        },
                        lender: {
                            id: data.requestBody.lenders?.[0]?.id,
                            name: data.requestBody.lenders?.[0]?.name,
                        },
                        borrower: {
                            id: null,
                            name: null,
                        },
                        lastUpdated: Math.floor(Date.now() / 1000),
                        createdAt: Math.floor(Date.now() / 1000),
                        type: tx.type || "LOAN",
                        originType: tx.type || "LOAN",
                        myRole: "BORROWER",
                        security: {
                            id: tx?.security?.id,
                            ticker: tx?.security?.ticker || "159580",
                            isin: tx?.security?.isin || "KR7159580000",
                            bbgCode: tx?.security?.bbgCode || "159580 KS",
                            localName: tx?.security?.localName || "제로투세븐",
                            market: tx?.security?.marketCode || "XKOS",
                            country: tx?.security?.countryCode || "KR",
                            currency: tx?.security?.currencyCode || "KRW",
                            name: "Pending",
                        },
                        requestedEconomics: {
                            quantity: tx?.quantity || 100,
                            fee: {
                                rateBp: tx.fee?.rateBp || 139,
                            },
                            intermediary: "ANY",
                            txType: "ANY",
                            valueDate: tx?.valueDate || "2024-03-06",
                            maturityDate: tx?.maturityDate || "9999-12-31",
                        },
                        needId: null,
                        unsolicitedOffer: false,
                        fundName:
                            data?.requestBody?.acceptanceCriteria?.fundName ||
                            "Fund A",
                        ksfcFundCode: "00095AA00002",
                        internalFundCode: "01",
                        uniqueId:
                            "TxEntry-2024-03-09+09:00_BORROWER-CPTY-2-CPTY-X-477381",
                        canceled: false,
                        createdDateAsISOStringRole: "2024-03-09+09:00_BORROWER",
                        state: TX_STATES.PRE_LOAN_REQUESTED,
                    })),
                    state: TX_STATES.PRE_LOAN_REQUESTED,
                });
            }

            // Listen for messages from the worker
            workerInstance.onmessage = (response) => {
                const result = response.data;
                dispatch({
                    type: Tx.INIT_SENT,
                    correlationId: result.correlationId,
                });
                dispatch({
                    type: Tx.INSERT_BORROW_TX_LIST,
                    txSet: result.txSet.map((tx) => ({
                        ...tx,
                        state: TX_STATES.PRE_LOAN_REQUESTED,
                    })),
                    state: TX_STATES.PRE_LOAN_REQUESTED,
                });

                dispatch({ type: Tx.RESET_INIT });
                dispatch(SpinnerActions.Close());
                dispatch(ModalActions.CloseAll());
                // Terminate the worker after processing the message
                workerInstance.terminate();
            };

            // Handle errors from the worker
            workerInstance.onerror = (err) => {
                console.error(err);
                dispatch(SpinnerActions.Close());
                dispatch({ type: Tx.INIT_ERROR, err });
                // Terminate the worker in case of an error
                workerInstance.terminate();
            };
        };
    },
    uploadInventory: (data) => {
        return (dispatch, getState) => {
            const workerInstance = new Worker(
                "workers/uploadInventoryWorker.js"
            );
            workerInstance.postMessage(data);
            workerInstance.onmessage = (response) => {
                dispatch(ModalActions.CloseAll());
                dispatch(
                    SpinnerActions.Close({
                        spinnerType: SpinnerTypes.INVENTORY,
                    })
                );
                workerInstance.terminate();
            };
            workerInstance.onerror = (err) => {
                console.error(err);
                dispatch(ModalActions.CloseAll());
                dispatch(
                    SpinnerActions.Close({
                        spinnerType: SpinnerTypes.INVENTORY,
                    })
                );
                dispatch({
                    type: Inventory.ERROR,
                    error: {
                        type: ERRORS.UPLOAD_SEND,
                        message: err.message,
                    },
                });
                dispatch(ToasterActions.NewError("Error uploading inventory"));
                // Terminate the worker in case of an error
                workerInstance.terminate();
            };
        };
    },
    updateInventory: (data) => {
        return (dispatch) => {
            const workerInstance = new Worker(
                "workers/updateInventoryWorker.js"
            );
            workerInstance.postMessage(data);
            workerInstance.onmessage = (response) => {
                dispatch(ModalActions.CloseAll());
                dispatch(
                    SpinnerActions.Close({
                        spinnerType: SpinnerTypes.INVENTORY,
                    })
                );
                workerInstance.terminate();
            };
            workerInstance.onerror = (err) => {
                console.error(err);
                dispatch(ModalActions.CloseAll());
                dispatch(
                    SpinnerActions.Close({
                        spinnerType: SpinnerTypes.INVENTORY,
                    })
                );
                dispatch({
                    type: Inventory.ERROR,
                    error: {
                        type: ERRORS.UPLOAD_SEND,
                        message: err.message,
                    },
                });
                dispatch(ToasterActions.NewError("Error updating inventory"));
                // Terminate the worker in case of an error
                workerInstance.terminate();
            };
        };
    },
};
